<template>
<el-dialog class="doc_send_dialog" title="修改文书" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" :before-close="recordClose" width="550px" center>
    <div class="doc_send_wrap">
        <el-form :model="docsendForm" :rules="docsendrules" ref="docsendForm" label-position="left" label-width="100px" size="small" :hide-required-asterisk="true">
            <div class="notice">
                <img src="@/assets/casespace/notice.png" style="width:18px; margin-right:5px;" alt="">下载系统自动生成文书，本地修改后上传，发送后将自动附上签字
            </div>
            <div class="download">
                未找到下载文书？ <a>点击再次下载</a>
            </div>
            <el-form-item label="选择文件" prop="fileName">
                <el-row>
                    <el-col :span="16">
                        <el-input v-model="docsendForm.fileName" placeholder="请上传文书" clearable @clear="handleClearFile"></el-input>
                    </el-col>
                    <el-col :span="8">
                        <el-upload class="upload-doc" ref="upload" :action="fileUploads.actionUrl" :accept="fileUploads.acceptType" :headers="fileUploads.flk" :http-request="handleRequestRecord" :on-remove="handleRemove" :on-change="handleChange" :show-file-list="false" :auto-upload="false">
                            <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
                        </el-upload>
                    </el-col>
                </el-row>
                <div class="el-upload__tip">只能上传pdf/doc/docx文件，{{maxFileTip}}</div>
            </el-form-item>
        </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="recordClose(null)">取 消</el-button>
        <el-button type="primary" :loading="BtnLoading" @click="handleSendBook">发送</el-button>
    </div>
</el-dialog>
</template>

<script>
import {
    docBookAttaList,
    signDocBook,
    refreshToken,
    getMediationRoomUserInfoList,
    sendDocBook,
    queryDocTempList
} from "@/api/casespace_doclist.js";
import {
    getStore
} from '@/utils/utils.js'
import config from '@/config/config.js'
import filedownload from '@/api/filedown.js'
import {
    constants
} from 'zlib';
import {maxFileLength, maxFileWarning, maxFileTip} from "../../../utils/utils";
export default {
    data() {
        return {
            maxFileTip: maxFileTip,
            docData:[
                {
                    docId:'0',
                    docName:'庭审笔录',
                },
                {
                    docId:'1',
                    docName:'送达回证',
                },
                {
                    docId:'2',
                    docName:'仲裁调解书',
                }
            ],
            docType: '0',
            dialogVisible: false,
            docsendForm: {
                resource: "2",
                status: "SEND_DOCUMENT",
                type: "",
                fileName: "",
                files: null,
                userlist: []
            },
            typeOptions: [],
            docsendrules: {
                fileName: [{
                    required: true,
                    message: '请上传文书',
                    trigger: 'change'
                }],
                userlist: [{
                    required: true,
                    message: '请选择人员',
                    trigger: 'change'
                }]
            },
            fileUploads: {
                actionUrl: `${config.baseURL}/gzzc/docBook/upload`,
                acceptType: '.pdf,.doc,.docx',
                flk: {
                    JWTToken: getStore('flk'),
                    appName: config.appName,
                    cType: 'PC'
                },
                fileData: {
                    isView: 'NOVIEW'
                },
                fileList: "",
                fileJson: []
            },
            buttonStatus: false,
            BtnLoading: false,
            curRoomId: null,
            curCaseId: null,
            curRoomUserList: {},
            curRoomUserIdList: [],
            docObj: {}
        }
    },
    created() {
        this.curCaseId = this.$route.params.id
        this.curRoomId = this.$route.query.bizRoomId
    },
    computed: {
        typeVisible() {
            return this.docsendForm.status == 'SIGN_DOCUMENT'
        }
    },
    methods: {
        openDocDialog() {
            console.log('opendialog-----')
            let userData = {}
            this.getDocTempList()
            getMediationRoomUserInfoList({
                "id": this.curCaseId
            }).then(res => {
                if (res.data.code === 1000) {
                    res.data.data.forEach(element => {
                        userData[element.userId] = element
                    })
                    this.curRoomUserList = userData
                    this.curRoomUserIdList = res.data.data.map(item => {
                        return {
                            id: item.userId,
                            name: item.userName
                        }
                    })
                }
                this.dialogVisible = true
            }, err => {
                this.dialogVisible = true
            })
        },
        recordClose(done) {
            this.$refs["docsendForm"].resetFields();
            done ? done() : this.dialogVisible = false
        },
        getDocTempList() {
            let defaultValue = ""
            queryDocTempList({
                "onlineStatus": 1,
                "pageIndex": 1,
                "bizCode": 'gzzc_ts',
                "pageSize": 200
            }).then(res => {
                if (res.data.code === 1000) {
                    this.typeOptions = res.data.data.list
                    res.data.data.list.forEach(element => {
                        this.docObj[element.docType] = element.docName
                    });
                    if (res.data.data.list[0]) {
                        defaultValue = res.data.data.list[0].docType
                    }
                    this.$set(this.docsendForm, 'type', defaultValue)
                }
            })
        },
        handleRemove(file, fileList) {
            //删除文件（上传）
            this.fileUploads.fileList = fileList
        },
        handleChange(file, fileList) {
            if (file.size > maxFileLength) {
                this.$message({
                    type: 'warning',
                    message: maxFileWarning
                });
                return false
            }
            let tempRet = /\.[^.]+$/.exec(file.name)
            let isAcceptType = true
            if (tempRet) {
                if (!~this.fileUploads.acceptType.indexOf(tempRet[0])) {
                    isAcceptType = false
                }
            }
            if (!isAcceptType) {
                this.$message({
                    type: 'warning',
                    message: '文件只支持' + this.fileUploads.acceptType + '等格式'
                });
                fileList.pop()
                return
            }
            if (tempRet.index > 20) {
                this.$message({
                    type: 'warning',
                    message: '文件名不超过20个字符长度'
                })
                return false
            }
            this.docsendForm.fileName = file.name
        },
        handleRequestRecord(file) {
            this.docsendForm.files = file.file
        },
        handleClearFile() {
            this.$refs.upload.clearFiles()
        },
        handleSendBook() {
            let self = this,
                checkedDoc = null
            this.$refs['docsendForm'].validate((valid) => {
                if (valid) {
                    self.$refs.upload.submit();
                    let params = new FormData()
                    self.docsendForm.userlist.forEach((element, index) => {
                        params.append(`docPersonList[${index}].meetingUserType`, self.curRoomUserList[element].meetingUserType ? self.curRoomUserList[element].meetingUserType : '')
                        params.append(`docPersonList[${index}].userId`, self.curRoomUserList[element].userId ? self.curRoomUserList[element].userId : '')
                        params.append(`docPersonList[${index}].userName`, self.curRoomUserList[element].userName ? self.curRoomUserList[element].userName : '')
                        params.append(`docPersonList[${index}].mobilePhone`, self.curRoomUserList[element].mobilePhone ? self.curRoomUserList[element].mobilePhone : '')
                        params.append(`docPersonList[${index}].idCard`, self.curRoomUserList[element].idCard ? self.curRoomUserList[element].idCard : '')
                        params.append(`docPersonList[${index}].agentType`, self.curRoomUserList[element].agentType ? self.curRoomUserList[element].agentType : '')
                    })
                    params.append('docId', '')
                    params.append('meetingId', '')
                    params.append('caseId', self.curCaseId)
                    params.append('fileName', self.docsendForm.fileName)
                    if (self.docsendForm.files) {
                        params.append('uploadFile', self.docsendForm.files)
                    } else {
                        this.$message.warning('请上传文书')
                        return
                    }
                    self.BtnLoading = true
                    if (self.docsendForm.status == 'SIGN_DOCUMENT') {
                        checkedDoc = self.typeOptions.find(item => {
                            return item.docType == self.docsendForm.type
                        })
                        params.append('docName', self.docObj[self.docsendForm.type])
                        params.append('docType', self.docsendForm.type)
                        signDocBook(params).then(res => {
                            if (res.data.code === 1000) {
                                self.$emit('compontCallback', {
                                    "receivers": self.docsendForm.userlist.join(),
                                    "fileId": res.data.data.fileId,
                                    "docsendtype": self.docsendForm.type,
                                    "docId": res.data.data.docId,
                                    "attachId": res.data.data.attachId,
                                    "fileName": res.data.data.fileName,
                                    "filePath": res.data.data.filePath,
                                    "source": self.docsendForm.status,
                                    "downloadFlag": checkedDoc.downloadFlag
                                })
                                self.$refs["docsendForm"].resetFields();
                                self.dialogVisible = false
                            } else {
                                self.$message({
                                    message: res.data.message,
                                    type: 'error'
                                })
                            }
                            self.BtnLoading = false
                        }, err => {
                            self.BtnLoading = false
                        })
                    } else if (self.docsendForm.status == 'SEND_DOCUMENT') {
                        sendDocBook(params).then(res => {
                            if (res.data.code === 1000) {
                                self.$emit('compontCallback', {
                                    "receivers": self.docsendForm.userlist.join(),
                                    "fileId": res.data.data.fileId,
                                    "docsendtype": self.docsendForm.type,
                                    "docId": res.data.data.docId,
                                    "attachId": res.data.data.attachId,
                                    "fileName": res.data.data.fileName,
                                    "filePath": res.data.data.filePath,
                                    "source": self.docsendForm.status,
                                    "downloadFlag": true
                                })
                                self.$refs["docsendForm"].resetFields();
                                self.dialogVisible = false
                            } else {
                                self.$message({
                                    message: res.data.message,
                                    type: 'error'
                                })
                            }
                            self.BtnLoading = false
                        }, err => {
                            self.BtnLoading = false
                        })
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })

        },
        downLoadTemplate() {
            let result = this.typeOptions.find(item => {
                return item.docType === this.docsendForm.type
            })
            let temp = result.docTemp
            console.log('没有key会报错', temp)
            if (temp && temp.value) {
                let url = temp.value
                console.log('下载url-----', url)
                window.open(url)
                // let name = temp.desc + '模版.doc'
                // filedownload('/pisces/file/clerkModelDownload', {
                //     url: url,
                // }, name)
            } else {
                console.log('weishameizou')
                this.$message({
                    message: "暂无模版,请于管理平台上传模版",
                    type: 'error'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.doc_send_dialog {
    .el-dialog__body {
        padding: 25px 25px 0;
    }

    .doc_send_wrap {
        margin: 0 25px;

        .notice{
            width: 100%;
            height: 25px;
            display: flex;
            align-items: center;
        }

        .download{
            width: 100%;
            height: 25px;
            display: flex;
            align-items: center;
            padding-left: 25px;
            margin-bottom: 20px;
            a{
                cursor: pointer;
                text-decoration: underline;
                color: #428BC6;
            }
        }

        .doc_template{
            margin-left: 15px;
            text-decoration: underline;
            color:#428BC6;
        }
        .upload-doc {
            .el-upload {
                width: 100%;
                text-align: left;
                padding-left: 8px;
            }
        }

        .doc_type {
            width: 100%;
        }
    }

    .dialog-footer {
        padding-bottom: 20px;

        .el-button {
            width: 120px;
            height: 40px;
        }
    }

    .el-button+.el-button {
        margin-left: 40px;
    }
}
</style>
